const livePlayerDefaults = {
  topMargin: 'xlarge',
  topMarginDesktop: 'xlarge',
}

const livePlayer = {
  dcl: {
    topMargin: 'base',
    topMarginDesktop: 'none',
  },

  lionsCreativity: {
    topMargin: 'xlarge',
    topMarginDesktop: 'xlarge',
  },

  lionsLive: {
    ...livePlayerDefaults,
  },
}

export default livePlayer
